import React from "react";
import Padding from "../../../features/tools/layout/padding/Editor/Padding";
import Align from "../../../features/tools/layout/align/Editor/Align";

const BatchEditorLayoutPanel = () => {
  return (
    <>
      <Padding />
      <Align />
    </>
  );
};

export default BatchEditorLayoutPanel;
